<h1>Admin Fleeces By Alpaca</h1>

<app-admin-fleeces-edit [alpacaId]="'16C254DB-DD75-4CD3-9967-0D6C1D1B0DFB'"></app-admin-fleeces-edit>